/**
 * O SINO do cabeçalho — onde qualquer pessoa liga os avisos, de qualquer tela
 * (14/08).
 *
 * POR QUE ELE EXISTE: o convite de ativar só aparecia no Motorista e em Meus
 * pedidos. Quem trabalha no Escritório — justamente quem recebe "pedido novo
 * chegou" — não tinha onde ativar, e a conclusão natural era que o push do
 * sistema não funcionava. Não funcionava mesmo: faltava o botão.
 *
 * Aqui ele fica no topo, ao lado do nome, em TODA tela e para todo módulo. E
 * quando não dá para ativar, diz o motivo em vez de sumir.
 */

import { ativarPush, diagnosticoDoAparelho, suportaPush } from './push.js';
import { avisar, avisarBloqueante } from './aviso.js';

export function instalarSino(dentro: HTMLElement): void {
  if (!suportaPush()) return;

  const botao = document.createElement('button');
  botao.className = 'sino';
  botao.type = 'button';
  botao.innerHTML = '🔔<span class="sino-texto">Ativar avisos</span>';
  botao.title = 'Receber avisos do sistema neste aparelho';
  dentro.prepend(botao);

  const pintar = async () => {
    const d = await diagnosticoDoAparelho();
    if (d.inscrito) {
      botao.classList.add('ligado');
      botao.innerHTML = '🔔<span class="sino-texto">Avisos ligados</span>';
      botao.title = 'Este aparelho já recebe os avisos do sistema';
    } else if (d.impedimento) {
      botao.classList.add('atencao');
      botao.innerHTML = '🔕<span class="sino-texto">Ativar avisos</span>';
      botao.title = d.impedimento;
    }
  };
  void pintar();

  botao.addEventListener('click', () => {
    void (async () => {
      const d = await diagnosticoDoAparelho();
      if (d.inscrito) {
        avisar('Este aparelho já está recebendo os avisos. Para conferir, use o teste em Administração ▸ Avisos.');
        return;
      }
      botao.disabled = true;
      const r = await ativarPush();
      botao.disabled = false;
      if (r.estado === 'ativado') {
        avisar('Pronto — este aparelho vai receber os avisos do sistema.');
        void pintar();
      } else {
        avisarBloqueante(r.detalhe);
        void pintar();
      }
    })();
  });
}
